import _ from 'lodash';

import { FIREBASE_CONFIG } from '../config';
import AccountsService from './AccountsService';

// function isUserLoggedIn() {
//   // const key = Object.keys(localStorage).find((e) => e.match(/firebase:authUser/));
//   // const data = JSON.parse(localStorage.getItem(key));
//   // console.log('data', data);
//   let result = false;
//   if (data == null) {
//     result = false;
//   } else if (!data.emailVerified) {
//     result = 'UnVerified';
//   } else if (!localStorage.getItem('account')) {
//     result = 'SelectAccount';
//   } else {
//     result = 'Verified';
//   }
//
//   console.log('isUserLoggedIn', result);
//   return result;
// }

const getFirebaseUser = () => {
  const key = Object.keys(localStorage).find((e) => e.match(/firebase:authUser/));
  const data = JSON.parse(localStorage.getItem(key));

  return data; //_.assign(data, { accounts, currentAccount });
};

const getProfile = () => {
  return JSON.parse(localStorage.getItem('profile'));
}

// const getProfile = () => {
//   const accounts = JSON.parse(localStorage.getItem('accounts'));
//   const currentAccount = JSON.parse(localStorage.getItem('account'));
//
//   console.log('emp', accounts[currentAccount.id].employee);
//   return accounts[currentAccount.id].employee;
// };

const hasPermission = (requestedPermissions) => {
  const currentAccount = AccountsService.getAccount();
  // console.log('currentAccount', currentAccount);
  if (!currentAccount || !currentAccount.permissions) {
    return false;
  }

  if (!_.isArray(requestedPermissions)) {
    requestedPermissions = [requestedPermissions];
  }

  const allowed = _.keys(currentAccount.permissions || {}).find((permission) => requestedPermissions.includes(permission));

  return allowed;
};

const resendEmailVerification = (userId) => {
  console.log('resendEmailVerification', userId);
  return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/auth/verifyemail`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: userId,
  }).then((res) => {
    console.log('resendEmailVerification', res);
    return res;
  }).catch((err) => {
    console.error(err);
  });
};

export {
  // isUserLoggedIn,
  getFirebaseUser,
  hasPermission,
  getProfile,
  resendEmailVerification,
};



// WEBPACK FOOTER //
// ./src/utils/authenticated.js